import { GetLoadables } from './loader';
// #if process.env.UIX_CHUNKED === 'true'
let loader = ()=>{
    return import(/* webpackChunkName: 'pdf' */ './pdfLoad');
};
const P = GetLoadables(loader, [
    'Document',
    'Page',
    'Outline'
]);
// #endif
// #if process.env.UIX_CHUNKED === 'false'
// import * as P from './pdfLoad'
// #endif
export let { Document, Page, Outline } = P;
